module.exports = __webpack_public_path__ + "img/top_title_parts3.d5f6d2f7.png";